import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { MoodboardGenerationService, GenFabEntry } from 'src/app/services/moodboard-generation.service';

@Component({
  selector: 'app-moodboard-gen-fab',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './moodboard-gen-fab.component.html',
})
export class MoodboardGenFabComponent {
  expanded = false;

  constructor(
    public genTracking: MoodboardGenerationService,
    private router: Router,
  ) {}

  get entries(): GenFabEntry[] {
    return this.genTracking.getFabEntries();
  }

  get processingCount(): number {
    return this.entries.filter(e => e.status === 'processing').length;
  }

  get completedCount(): number {
    return this.entries.filter(e => e.status === 'completed').length;
  }

  get summaryLabel(): string {
    const p = this.processingCount;
    const c = this.completedCount;
    if (p > 0 && c > 0) return `${p} Generating · ${c} Ready`;
    if (p > 0) return p === 1 ? 'Generating Look…' : `${p} Generating`;
    if (c > 0) return c === 1 ? 'Look Ready ✓' : `${c} Looks Ready ✓`;
    return '';
  }

  get isAnyComplete(): boolean {
    return this.completedCount > 0;
  }

  viewResult(entry: GenFabEntry): void {
    this.genTracking.clearCompleted(entry.imageId);
    this.router.navigate(
      ['/layout/moodboard/entity-edit', entry.moodboardId, entry.entityVersionId],
      { queryParams: { openVariationDrawerImageId: entry.imageId } },
    );
    if (this.entries.length === 0) this.expanded = false;
  }

  dismiss(entry: GenFabEntry, event: Event): void {
    event.stopPropagation();
    this.genTracking.clearCompleted(entry.imageId);
    if (this.entries.length === 0) this.expanded = false;
  }
}
